document.addEventListener('click', function (e) {
const prevArrow = e.target.closest(
    '.section-layout-type-new .thumbnail-slider .thumbnail-slider-prev-arrow'
);
const nextArrow = e.target.closest(
    '.section-layout-type-new .thumbnail-slider .thumbnail-slider-next-arrow'
);

if (prevArrow) {
    const parent = prevArrow.closest('.thumbnail-slider');
    const targetBtn = parent.querySelector('.slider-button.slider-button--prev');
    if (targetBtn) targetBtn.click();
    const dots = parent.querySelectorAll('.slider-dots .slider-dot');
    if (dots.length >= 2) {
      dots[0].classList.add('slider-dot--active');
      dots[1].classList.remove('slider-dot--active');
    }
}

if (nextArrow) {
    const parent = nextArrow.closest('.thumbnail-slider');
    const targetBtn = parent.querySelector('.slider-button.slider-button--next');
    if (targetBtn) targetBtn.click();
    const dots = parent.querySelectorAll('.slider-dots .slider-dot');
    if (dots.length >= 2) {
      dots[0].classList.remove('slider-dot--active');
      dots[1].classList.add('slider-dot--active');
    }
}
});


document.addEventListener('DOMContentLoaded', () => {
  const triggers = document.querySelectorAll('.scroll-on-product-section');
  const productInfo = document.querySelector('product-info');

  if (!productInfo || !triggers.length) return;

  triggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();

      productInfo.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  });
});



document.addEventListener('DOMContentLoaded', () => {
  // All product media images from first slider-component
  const productImages = document.querySelectorAll(
    'slider-component .product__media img'
  );

  if (!productImages.length) return;

  /* =========================
     2nd IMAGE → rl-powerful
     ========================= */
  const rlPowerfulImg = document.querySelector(
    '.rl-powerful-wrapper .rl-powerful-image img'
  );

  if (rlPowerfulImg && productImages.length >= 2) {
    rlPowerfulImg.src = productImages[1].getAttribute('src');
  }

  /* =========================
     LAST IMAGE → rbf-center-img
     ========================= */
  // const rbfCenterImages = document.querySelectorAll(
  //   '.rbf-center-img-wrap img'
  // );

  // if (rbfCenterImages.length) {
  //   const lastImageSrc =
  //     productImages[productImages.length - 1].getAttribute('src');

  //   rbfCenterImages.forEach(img => {
  //     img.src = lastImageSrc;
  //   });
  // }
});


document.addEventListener('DOMContentLoaded', function () {
  const buyNowBtn = document.querySelector('.additional-static-checkout-btn');
  if (!buyNowBtn) return;
  buyNowBtn.addEventListener('click', function (e) {
    e.preventDefault();
    const form = document.querySelector('form[action="/cart/add"]');
    if (!form) return;
    const variantId = form.querySelector('input[name="id"]').value;
    const quantityInput = form.querySelector('input[name="quantity"]');
    const quantity = quantityInput ? quantityInput.value : 1;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    })
    .then(response => response.json())
    .then(() => {
      window.location.href = '/checkout';
    })
    .catch(error => {
      console.error('Add to cart error:', error);
    });
  });
});



(function () {
  function applyRatingLogic() {
    const ratingTextEl = document.querySelector('#seal-star-rating-widget .tt-rating-text');
    const starEl = document.querySelector('.product-icon-list.vstar-star');
    const heroRatingEl = document.querySelector('.hero-rating.static-reviews-block');
    if (!ratingTextEl || !starEl || !heroRatingEl) return false;
    const text = ratingTextEl.textContent.replace(/\s+/g, ' ').trim();
    const match = text.match(/^(\d+)/);
    if (!match) return false;
    const reviewCount = parseInt(match[1], 10);
    if (reviewCount === 0) {
      starEl.style.display = 'none';
      heroRatingEl.style.display = '';
    } else {
      starEl.style.display = '';
      heroRatingEl.style.display = 'none';
    }
    return true;
  }
  if (applyRatingLogic()) return;
  let attempts = 0;
  const interval = setInterval(() => {
    attempts++;
    if (applyRatingLogic() || attempts > 20) {
      clearInterval(interval);
    }
  }, 300);
  const observer = new MutationObserver(() => {
    applyRatingLogic();
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();





